import { render, staticRenderFns } from "./QuestionDet.vue?vue&type=template&id=70d3176e&scoped=true&"
import script from "./QuestionDet.vue?vue&type=script&lang=ts&"
export * from "./QuestionDet.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionDet.vue?vue&type=style&index=0&id=70d3176e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d3176e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VCol,VInput,VRating,VRow,VTextarea})
